import { Controller } from "@hotwired/stimulus"

// Sizes the iframe to the content height its embedded page reports via
// postMessage({ iframeHeight: <px> }).
export default class extends Controller {
  static values = { origin: String }

  connect() {
    this.resize = (event) => {
      if (event.source !== this.element.contentWindow || event.origin !== this.originValue) return

      const height = parseInt(event.data?.iframeHeight, 10)
      if (height > 0) this.element.style.height = `${height}px`
    }
    window.addEventListener("message", this.resize)
  }

  disconnect() {
    window.removeEventListener("message", this.resize)
  }
}
